// src/utils/mockData.js

/**
 * Datos MOCK para desarrollo del Dashboard Stoneweg
 * Basados en las imágenes proporcionadas
 */

// ============================================
// KPIs GLOBALES (Imagen 1)
// ============================================

export const mockKPIsGlobales = {
  success: true,
  data: {
    global: [
      {
        kpi: 'numero_companias',
        valor: 35,
        unidad: 'count',
        variacion: 15.6,
        isPositive: true,
      },
      {
        kpi: 'ingresos_totales',
        valor: 10370000,
        unidad: 'EUR',
        variacion: 8.3,
        isPositive: true,
      },
      {
        kpi: 'total_invertido',
        valor: 100370000,
        unidad: 'EUR',
        variacion: 12.5,
        isPositive: true,
      },
      {
        kpi: 'precio_promedio_ticket',
        valor: 140,
        unidad: 'EUR',
        variacion: 5.2,
        isPositive: true,
      },
      {
        kpi: 'objetivo_vs_real',
        valor: 140,
        unidad: 'EUR',
        variacion: -2.1,
        isPositive: false,
      },
      {
        kpi: 'num_empleados',
        valor: 225,
        unidad: 'count',
        variacion: -3.4,
        isPositive: false,
      },
      {
        kpi: 'costes_totales',
        valor: 9000000,
        unidad: 'EUR',
        variacion: 4.8,
        isPositive: false,
      },
      {
        kpi: 'total_activo',
        valor: 110000000,
        unidad: 'EUR',
        variacion: 7.2,
        isPositive: true,
      },
      {
        kpi: 'margen_operacion',
        valor: 24,
        unidad: '%',
        variacion: 3.5,
        isPositive: true,
      },
      {
        kpi: 'clientes',
        valor: 1200000,
        unidad: 'count',
        variacion: 18.9,
        isPositive: true,
      },
    ],
    ventas: [
      {
        kpi: 'visitantes_comparativa',
        reales: 12000,
        proyectados: 24000,
        desviacion_porcentaje: -50,
        unidad: 'personas',
      },
    ],
    timestamp: new Date().toISOString(),
  },
};

// ============================================
// VISITANTES REALES VS PROYECTADOS (Gráfico líneas)
// ============================================

// ============================================
// VISITANTES REALES VS PROYECTADOS (Gráfico líneas)
// Periodo: 01/08/2025 - 17/11/2025 (109 días)
// ============================================

export const mockVisitantesRealesVsProyectados = {
  data: [
    { day: 'Mon', projected: 3050, real: 2775, budget: 200000 },
    { day: 'Tue', projected: 3175, real: 2925, budget: 200000 },
    { day: 'Wed', projected: 3325, real: 3050, budget: 200000 },
    { day: 'Thu', projected: 3250, real: 2975, budget: 200000 },
    { day: 'Fri', projected: 3650, real: 3400, budget: 200000 },
    { day: 'Sat', projected: 4300, real: 4050, budget: 200000 },
    { day: 'Sun', projected: 4500, real: 4325, budget: 200000 },
  ],
  series: [
    { yKey: 'projected', name: 'Projected Visitors', color: '#ef4444' },
    { yKey: 'real', name: 'Real Visitors', color: '#10b981' },
  ],
};

// ============================================
// VISITANTES PARA BREAK EVEN (Gráfico barras apiladas)
// ============================================

export const mockVisitantesBreakEven = {
  data: [
    { day: 'Mon', medio: 7600, breakEven: 3450 },
    { day: 'Tue', medio: 7950, breakEven: 3700 },
    { day: 'Wed', medio: 8250, breakEven: 3900 },
    { day: 'Thu', medio: 8100, breakEven: 3750 },
    { day: 'Fri', medio: 9200, breakEven: 4300 },
    { day: 'Sat', medio: 10250, breakEven: 4950 },
    { day: 'Sun', medio: 10650, breakEven: 5200 },
  ],
  series: [
    { yKey: 'medio', name: 'Medio De Visitantes', color: '#3b82f6' },
    { yKey: 'breakEven', name: 'Media De Break-Even', color: '#f97316' },
  ],
};

// ============================================
// DISTRIBUCIÓN INGRESOS POR LÍNEA (Imagen 2)
// ============================================

export const mockDistribucionIngresos = [
  {
    linea: 'Proyectos',
    real: 370000,
    proyectado: 500000,
    desviacion: 25,
    color: '#f97316',
  },
  {
    linea: 'Eventos',
    real: 370000,
    proyectado: 500000,
    desviacion: 25,
    color: '#10b981',
  },
  {
    linea: 'Alquileres',
    real: 370000,
    proyectado: 500000,
    desviacion: 25,
    color: '#f97316',
  },
  {
    linea: 'Merchandaising',
    real: 370000,
    proyectado: 500000,
    desviacion: 25,
    color: '#10b981',
  },
];

// ============================================
// TOTAL INVERTIDO VS EBITDA (Gráfico líneas)
// ============================================

export const mockInvertidoVsEbitda = {
  data: [
    { month: 'Jan', invertido: 8200000, ebitda: 7850000 },
    { month: 'Feb', invertido: 8450000, ebitda: 8100000 },
    { month: 'Mar', invertido: 8750000, ebitda: 8350000 },
    { month: 'Apr', invertido: 8500000, ebitda: 8200000 },
    { month: 'May', invertido: 8900000, ebitda: 8550000 },
    { month: 'Jun', invertido: 9100000, ebitda: 8700000 },
    { month: 'Jul', invertido: 9500000, ebitda: 9150000 },
  ],
  series: [
    { yKey: 'invertido', name: 'Total Invertido', color: '#ef4444' },
    { yKey: 'ebitda', name: 'Total Ebitda', color: '#10b981' },
  ],
  distribucion: [
    { linea: 'Proyectos', valor: 3125000, color: '#ef4444' },
    { linea: 'Eventos', valor: 886000, color: '#10b981' },
    { linea: 'Alquileres', valor: 410000, color: '#3b82f6' },
    { linea: 'Merchandising', valor: 850000, color: '#f97316' },
    { linea: 'Food & Beverage', valor: 380000, color: '#8b5cf6' },
  ],
};

// ============================================
// APALANCAMIENTO (Gráfico dona - Imagen 2)
// ============================================

export const mockApalancamientoArea = {
  data: [
    { label: 'Bancos', value: 32600000, color: '#3b82f6' },      // 32.6M €
    { label: 'Accionistas', value: 18600000, color: '#10b981' }, // 18.6M €
    { label: 'Externos', value: 28600000, color: '#f97316' },    // 28.6M €
  ],
};

// ============================================
// DEUDA POR ÁREA (Barras horizontales)
// ============================================

export const mockDeudaPorArea = [
  { area: 'Bancos', porcentaje: 92, color: '#f97316' },
  { area: 'Accionistas', porcentaje: 88, color: '#f97316' },
  { area: 'Financiadores externos', porcentaje: 95, color: '#f97316' },
];

// ============================================
// ACTIVOS POR ÁREA (Barras horizontales)
// ============================================

export const mockActivosPorArea = [
  { area: 'Patrimonio neto', porcentaje: 45, color: '#f97316' },
  { area: 'Activos inmobiliarios / patrimoniales', porcentaje: 35, color: '#f97316' },
  { area: 'Activos operativos', porcentaje: 20, color: '#f97316' },
];

// ============================================
// RETRASOS E IMPAGOS (Imagen 3 - Gráfico dona)
// ============================================

export const mockRetrasosImpagos = {
  data: [
    { label: 'Clientes', value: 33, color: '#3b82f6' },
    { label: 'Accionistas', value: 19, color: '#10b981' },
    { label: 'Externos', value: 48, color: '#f97316' },
  ],
};

// ============================================
// PRINCIPALES ACREEDORES (Barras horizontales)
// ============================================

export const mockPrincipalesAcreedores = [
  { acreedor: 'Caixa Cataluña', porcentaje: 45, color: '#f97316' },
  { acreedor: 'Área Metropolitana de Barcelona (AMB)', porcentaje: 35, color: '#f97316' },
  { acreedor: 'Fondos Next Generation', porcentaje: 20, color: '#f97316' },
];

// ============================================
// GRUPOS DE COSTES (Imagen 3)
// ============================================

export const mockGruposCostes = [
  { grupo: 'Alquiler', valor: 600000, color: '#f97316' },
  { grupo: 'Consumibles', valor: 250000, color: '#f97316' },
  { grupo: 'Personal', valor: 700000, color: '#f97316' },
];

// ============================================
// DISTRIBUCIÓN COSTES (Gráfico dona)
// ============================================

export const mockDistribucionCostes = {
  data: [
    { label: 'Alquileres', value: 36.4, color: '#3b82f6' },   // 600k/1550k
    { label: 'Consumibles', value: 16.1, color: '#10b981' },  // 250k/1550k
    { label: 'Personal', value: 45.2, color: '#f97316' },     // 700k/1550k
    // O usa estos valores en euros si el componente lo permite:
    // { label: 'Alquileres', value: 600000, color: '#3b82f6' },
    // { label: 'Consumibles', value: 250000, color: '#10b981' },
    // { label: 'Personal', value: 700000, color: '#f97316' },
  ],
};

// ============================================
// PRINCIPALES SUBGRUPOS COSTES
// ============================================

export const mockSubgruposCostes = [
  { subgrupo: 'Camareros', porcentaje: 45, valor: 315000, color: '#f97316' },
  { subgrupo: 'Cocineros', porcentaje: 35, valor: 245000, color: '#f97316' },
  { subgrupo: 'Comida', porcentaje: 20, valor: 140000, color: '#f97316' },
];

// ============================================
// MERCHANDISING (Imagen 4)
// ============================================

export const mockMerchandising = {
  totalVentas: 1365000,
  ticketMedio: 25,
  porcentajeCompran: 10,
  margen: 25,
};

export const mockMerchandisingBarras = [
  { metrica: 'Total ventas Merchandaising', valor: 1365000, max: 2000000, color: '#f97316' },
  { metrica: 'Ticket medio Merchandaising', valor: 25, max: 50, color: '#f97316' },
  { metrica: '% de Visitantes que compran', valor: 10, max: 100, color: '#f97316' },
  { metrica: 'Margen tienda', valor: 25, max: 100, color: '#f97316' },
];

// ============================================
// GESTIÓN INTERNA VS EXTERNA (Dona)
// ============================================

export const mockGestionInternaExterna = {
  data: [
    { label: 'Interna', value: 65, color: '#1e3a8a' },
    { label: 'Externa', value: 35, color: '#10b981' },
  ],
};

// ============================================
// PRINCIPALES SUBGRUPOS MERCHANDISING
// ============================================

export const mockSubgruposMerchandising = [
  { subgrupo: 'Ropa', porcentaje: 45, valor: 614250, color: '#f97316' },
  { subgrupo: 'Posters', porcentaje: 35, valor: 477750, color: '#f97316' },
  { subgrupo: 'Llaveros', porcentaje: 20, valor: 273000, color: '#f97316' },
];

// ============================================
// FOOD & BEVERAGE (Imagen 4)
// ============================================

export const mockFoodBeverage = {
  ingresosPorArea: [
    { area: 'Restaurante', valor: 150000, porcentaje: 15.6, color: '#10b981' },
    { area: 'Bar', valor: 86000, porcentaje: 15.6, color: '#10b981' },
    { area: 'Catering', valor: 46000, porcentaje: 15.6, color: '#10b981' },
  ],
  margenPorArea: [
    { area: 'Restaurante', porcentaje: 28, variacion: 15.6, color: '#10b981' },
    { area: 'Bar', porcentaje: 41, variacion: 15.6, color: '#10b981' },
    { area: 'Catering', porcentaje: 55, variacion: 15.6, color: '#10b981' },
  ],
  productosVendidos: [
    { producto: 'Signature Dish', cantidad: 1234, porcentaje: 15.6 },
    { producto: 'House Special', cantidad: 987, porcentaje: 15.6 },
    { producto: 'Premium Drinks', cantidad: 856, porcentaje: 15.6 },
  ],
};

// ============================================
// CRM Y FUNNEL DE VENTAS (Imagen 5)
// ============================================

export const mockFunnelVentas = [
  { etapa: 'Leads', valor: 2500, max: 3000, color: '#f97316' },
  { etapa: 'Qualified', valor: 1200, max: 3000, color: '#f97316' },
  { etapa: 'Negotiation', valor: 450, max: 3000, color: '#f97316' },
  { etapa: 'Closed', valor: 200, max: 3000, color: '#f97316' },
];

export const mockMetricasCRM = [
  { metrica: 'CPL (Coste por lead)', valor: 35, unidad: '€', variacion: 5.2, isPositive: true },
  { metrica: 'CPA (Coste de adquisición)', valor: 150, unidad: '€', variacion: -3.1, isPositive: false },
  { metrica: 'LTV (Customer Lifetime Value)', valor: 3500, unidad: '€', variacion: 12.4, isPositive: true },
  { metrica: 'Retention Rate', valor: 33, unidad: '%', variacion: 2.8, isPositive: true },
];

// ============================================
// TICKETING (Imagen 5)
// ============================================

export const mockTicketing = {
  ventasTickets: [
    { metrica: 'Nº Tickets vendidos vs proyectados', real: 2500, proyectado: 5000, color: '#f97316' },
    { metrica: '% Ticket total ingresos vs proyectado', real: 33, proyectado: 45, unidad: '%', color: '#f97316' },
    { metrica: 'Precio medio ticket (PVP) vs proyectado', real: 35, proyectado: 50, unidad: '€', color: '#f97316' },
    { metrica: 'Nº Tickets devueltos vs proyectados', real: 200, proyectado: 150, color: '#ef4444' },
  ],
  metricasTicketing: [
    { metrica: 'CPL (Coste por lead)', valor: 35, unidad: '€', variacion: 5.2, isPositive: true },
    { metrica: 'CPA (Coste de adquisición)', valor: 150, unidad: '€', variacion: -3.1, isPositive: false },
    { metrica: 'LTV (Customer Lifetime Value)', valor: 3500, unidad: '€', variacion: 12.4, isPositive: true },
    { metrica: 'Retention Rate', valor: 33, unidad: '%', variacion: 2.8, isPositive: true },
  ],
};

// ============================================
// FUNCIÓN HELPER: Usar mock o API real
// ============================================

export const useMockData = process.env.REACT_APP_USE_MOCK === 'true';

export const getMockOrReal = async (apiCall, mockData) => {
  if (useMockData) {
    // Simular delay de red
    await new Promise((resolve) => setTimeout(resolve, 500));
    return mockData;
  }
  return apiCall();
};

export default {
  mockKPIsGlobales,
  mockVisitantesRealesVsProyectados,
  mockVisitantesBreakEven,
  mockDistribucionIngresos,
  mockInvertidoVsEbitda,
  mockApalancamientoArea,
  mockDeudaPorArea,
  mockActivosPorArea,
  mockRetrasosImpagos,
  mockPrincipalesAcreedores,
  mockGruposCostes,
  mockDistribucionCostes,
  mockSubgruposCostes,
  mockMerchandising,
  mockMerchandisingBarras,
  mockGestionInternaExterna,
  mockSubgruposMerchandising,
  mockFoodBeverage,
  mockFunnelVentas,
  mockMetricasCRM,
  mockTicketing,
  useMockData,
  getMockOrReal,
};